<template>
  <div v-loading="projectInstanceListLoading" class="wrapper_box">
    <div v-if="clusterNodeCount === 0" class="div_height_100">
      <div class="no-data">
        <el-empty :description="$t('computingCluster.resource.noClusterInfo')">
          <el-button type="text" @click="checkProjectTencentAccountExist()">
            {{ $t('computingCluster.resource.createNow') }}
          </el-button>
        </el-empty>
        <ExamineAKSK :examineAKSKVisible="examineAKSKVisible" :examineAKSKVisibleFalse="examineAKSKVisibleFalse" />
      </div>
    </div>
    <div v-else class="div_height_100" style="min-width: 1200px">
      <!-- 操作按钮 -->
      <div class="base-flex__between">
        <div class="switchMenuIcon">
          <i
            :class="changeDataViewType ? 'el-icon-s-operation' : 'el-icon-menu'"
            :title="$t('computingCluster.resource.switchViewMode')"
            class="base-cursor__pointer"
            @click="clickChangeDataViewType"
          ></i>
          <i
            :title="$t('computingCluster.resource.refreshList')"
            class="base-cursor__pointer el-icon-refresh base-margin__left-10"
            @click="getResourceList"
          ></i>
        </div>
        <div class="base-flex-wrap__wrap base-flex base-flex__end">
          <div class="base-text-align__right">
            <el-select
              v-model="instancechargeTypeList"
              :placeholder="$t('computingCluster.resource.billingMethod')"
              class="select-width-178 base-margin__right-10"
              collapse-tags
              filterable
              multiple
              @change="filterGetResourceList"
            >
              <el-option v-for="item in BillingTypeDataList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select
              v-model="nodeTypeList"
              :placeholder="$t('computingCluster.resource.nodeType')"
              class="select-width-178 base-margin__right-10"
              collapse-tags
              filterable
              multiple
              @change="filterGetResourceList"
            >
              <el-option v-for="item in NodeTypeFilterList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select
              v-model="statusList"
              :placeholder="$t('computingCluster.resource.clusterStatus')"
              class="select-width-178 base-margin__right-10"
              collapse-tags
              filterable
              multiple
              @change="filterGetResourceList"
            >
              <el-option v-for="item in CvmStatusFilterList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select
              v-model="queueNameList"
              :placeholder="$t('computingCluster.resource.clusterQueue')"
              class="select-width-178 base-margin__right-10"
              collapse-tags
              filterable
              multiple
              @change="filterGetResourceList"
            >
              <el-option v-for="item in queueNameFilterList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
            <el-input
              class="select-width-178 base-margin__right-10"
              @change="filterGetResourceList"
              v-model="selectInstanceId"
              clearable
              :placeholder="$t('customCluster.manage.instanceId')"
            ></el-input>
            <el-input
              class="select-width-178 base-margin__right-10"
              @change="filterGetResourceList"
              v-model="selectInstancePrivateIp"
              clearable
              :placeholder="$t('customCluster.manage.privateIp')"
            ></el-input>
          </div>
          <div class="base-text-align__right">
            <el-button :disabled="handleSelectionChangeData.length === 0" @click="batchDestruction">
              {{ $t('computingCluster.resource.batchDestroy') }}
            </el-button>
            <el-button
              v-if="
                isNotMaster &&
                projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1 &&
                !deployModeSimple
              "
              @click="clickMonitorDialog"
            >
              {{ $t('computingCluster.resource.performanceMonitor') }}
            </el-button>
            <el-button v-if="isNotMaster" type="primary" @click="clickCreateDialog">
              {{ $t('computingCluster.resource.createChildNode') }}
            </el-button>
            <el-button v-if="isNotMaster" type="primary" @click="importChildNode">
              {{ $t('computingCluster.resource.importChildNode') }}
            </el-button>
            <el-button
              v-if="isNotMaster"
              type="primary"
              :disabled="handleSelectionChangeData.length === 0"
              @click="exportNodeExcel"
              class="base-margin__right-10"
            >
              {{ $t('customCluster.baseInfo.export') }}
            </el-button>
          </div>
        </div>
      </div>

      <!-- 节点列表 -->
      <div v-if="changeDataViewType" class="overview">
        <div class="overview-wrapper">
          <!-- 节点信息 -->
          <div
            v-for="(item, index) in projectInstanceList"
            :key="index"
            class="content-item"
            @click="openDetails(item)"
          >
            <div class="overview-title">
              {{ filterNodeName(item.nodeType) }}

              <span>{{ item.instanceId }}</span>
              <span
                :class="`${statusFilter(item.status).class} create__button--right`"
                :style="`color:${statusFilter(item.status).color};float: right`"
                @click.stop="getProjectNodeDeploy('createMasterNode', item)"
              >
                {{ statusFilter(item.status).status }}
                <i
                  v-if="item.nodeType === 'master' && item.status === cvmStatusFilter.CvmStatusCreate"
                  class="el-icon-warning-outline"
                ></i>
                <el-tooltip class="item" effect="dark" :content="item.errMsg" placement="top-start">
                  <i v-if="item.status === cvmStatusFilter.CvmStatusAbnormal" class="el-icon-warning-outline"></i>
                </el-tooltip>
              </span>
            </div>
            <div class="form-container" style="label-position: left; label-width: 20%; font-size: 12px">
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.tags') }}</span>
                <span class="form-content">
                  <div v-if="item.tags" class="tagsInfo_box">
                    <el-tag v-for="list in item.tags" :key="list.id" size="mini">{{ list }}</el-tag>
                  </div>
                  <div v-else>-</div>
                </span>
              </div>
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.specification') }}</span>
                <span class="form-content">{{ item.instanceType }}</span>
              </div>
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.vCPU') }}</span>
                <span class="form-content">{{ item.cpu }}{{ $t('computingCluster.resource.core') }}</span>
              </div>
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.vGPU') }}</span>
                <span class="form-content">{{ item.gpu }}{{ $t('computingCluster.resource.card') }}</span>
              </div>
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.queue') }}</span>
                <span class="form-content">{{ item.queueName }}</span>
              </div>
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.platform') }}</span>
                <span class="form-content" :title="item?.osName">
                  <div class="base__overflow-hidden base__text-overflow">{{ item?.imagePlatform }}</div>
                </span>
              </div>
              <div v-if="item.instanceChargeType === 'POSTPAID_BY_HOUR'" class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.billingMethod') }}</span>
                <span class="form-content">{{ $t('computingCluster.resource.postpaid') }}</span>
              </div>
              <div v-if="item.instanceChargeType === 'SPOTPAID'" class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.billingMethod') }}</span>
                <span class="form-content">{{ $t('computingCluster.resource.spotpaid') }}</span>
              </div>
              <div v-if="item.instanceChargeType === 'PREPAID' && item.createdTime !== 0" class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.releaseTime') }}</span>
                <span class="form-content">{{ item.createdTime }}</span>
              </div>
              <div class="form-item split-item">
                <span class="form-label">{{ $t('computingCluster.resource.createTime') }}</span>
                <span class="form-content">{{ item.createTime || '-' }}</span>
              </div>
            </div>

            <!-- 单个节点操作部分-->
            <!-- 管理节点 -->
            <template v-if="item.nodeType === 'master'">
              <div v-if="isOwner === 1 || (isOwner === 0 && noLoginMaster)">
                <el-dropdown v-if="item.status === cvmStatusFilter.CvmStatusNormal" class="base-float__right">
                  <el-button class="form-button" type="primary" @click.stop="">
                    {{ $t('computingCluster.resource.login') }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <!--登录-->
                    <el-dropdown-item v-if="filterNodeShow('masterLogin')" command="common">
                      <p class="base-cursor__pointer" @click.stop="startNode(item.instanceId, 'common', item.nodeType)">
                        {{ $t('computingCluster.resource.login') }}
                      </p>
                    </el-dropdown-item>

                    <!--管理员登录-->
                    <el-dropdown-item v-if="filterNodeShow('adminLogin')" command="root">
                      <p class="base-cursor__pointer" @click.stop="startNode(item.instanceId, 'root', item.nodeType)">
                        {{ $t('computingCluster.resource.adminLogin') }}
                      </p>
                    </el-dropdown-item>

                    <!-- 主节点或登录节点的VNC重启选项 -->
                    <el-dropdown-item v-if="filterNodeShow('masterRestartVNC')">
                      <p class="base-cursor__pointer" @click.stop="restartVNC(item.instanceId)">
                        {{ $t('computingCluster.resource.restartVNC') }}
                      </p>
                    </el-dropdown-item>

                    <!-- 创建镜像 -->
                    <el-dropdown-item
                      v-if="filterNodeShow('masterCreateImages')"
                      :disabled="item.status !== cvmStatusFilter.CvmStatusNormal"
                      command="createImages"
                    >
                      <p class="base-cursor__pointer" @click.stop="createImages(item)">
                        {{ $t('computingCluster.resource.createImages') }}
                      </p>
                    </el-dropdown-item>
                    <!-- 更新 -->
                    <el-dropdown-item command="update">
                      <p class="base-cursor__pointer" @click.stop="updateEdactld">
                        {{ $t('common.update') }}
                      </p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>

              <!-- 释放实例按钮（仅当状态正常或部署中且为拥有者时显示） -->
              <el-button
                v-if="
                  (item.status === cvmStatusFilter.CvmStatusNormal ||
                    item.status === cvmStatusFilter.CvmStatusInDeployment) &&
                  isOwner === 1
                "
                :disabled="projectInstanceList.length > 1"
                :title="$t('computingCluster.resource.releaseAllNodesFirst')"
                class="form-button"
                @click.stop="releaseInstance(item.id, 'master')"
              >
                {{ $t('computingCluster.resource.release') }}
              </el-button>
              <!-- 重新创建按钮（当状态为销毁中或异常时显示） -->
              <el-button
                v-if="
                  (item.status === cvmStatusFilter.CvmStatusDestruction ||
                    item.status === cvmStatusFilter.CvmStatusAbnormal) &&
                  isOwner === 1
                "
                class="form-button"
                type="primary"
                @click.stop="recreate(item)"
              >
                {{ $t('computingCluster.resource.recreate') }}
              </el-button>
              <!-- 导入节点（当状态为销毁中或异常时显示） -->
              <el-button
                v-if="
                  (item.status === cvmStatusFilter.CvmStatusDestruction ||
                    item.status === cvmStatusFilter.CvmStatusAbnormal) &&
                  isOwner === 1
                "
                class="form-button"
                @click.stop="importMasterNode"
              >
                {{ $t('computingCluster.resource.importMasterNode') }}
              </el-button>
            </template>

            <!-- 计算节点 -->
            <template v-else>
              <!-- 非Windows系统且状态为正常的登录节点显示下拉菜单 -->
              <el-dropdown
                v-if="item.status === cvmStatusFilter.CvmStatusNormal && item.nodeType === 'login'"
                class="base-float__right"
              >
                <el-button class="form-button" type="primary" @click.stop="">
                  {{ $t('computingCluster.resource.login') }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- 普通登录选项 -->
                  <el-dropdown-item command="common">
                    <p class="base-cursor__pointer" @click.stop="startNode(item.instanceId, 'common', item.nodeType)">
                      {{ $t('computingCluster.resource.login') }}
                    </p>
                  </el-dropdown-item>
                  <!-- 重启VNC选项（仅对master节点所有者或登录节点可见） -->
                  <el-dropdown-item
                    v-if="projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1"
                    :disabled="item.status !== cvmStatusFilter.CvmStatusNormal"
                  >
                    <p class="base-cursor__pointer" @click.stop="restartVNC(item.instanceId)">
                      {{ $t('computingCluster.resource.restartVNC') }}
                    </p>
                  </el-dropdown-item>
                  <!-- 创建镜像 -->
                  <el-dropdown-item
                    v-if="filterNodeShow('childCreateImages')"
                    :disabled="item.status !== cvmStatusFilter.CvmStatusNormal"
                    command="createImages"
                  >
                    <p class="base-cursor__pointer" @click.stop="createImages(item)">
                      {{ $t('computingCluster.resource.createImages') }}
                    </p>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>

              <!-- 非预付费且状态为正常或部署中的节点显示释放按钮 -->
              <el-button
                v-if="
                  item.status === cvmStatusFilter.CvmStatusNormal ||
                  item.status === cvmStatusFilter.CvmStatusInDeployment
                "
                class="form-button"
                @click.stop="releaseInstance(item.id, 'child')"
              >
                {{ $t('computingCluster.resource.release') }}
              </el-button>
              <!--删除节点按钮-->
              <el-button
                v-if="
                  item.status === cvmStatusFilter.CvmStatusDestruction ||
                  item.status === cvmStatusFilter.CvmStatusAbnormal
                "
                class="form-button"
                type="danger"
                @click.stop="deleteNode(item.id)"
              >
                {{ $t('computingCluster.resource.delete') }}
              </el-button>

              <div class="base-flex base-float__right">
                <!--删除节点按钮-->
                <el-button
                  class="form-button"
                  v-if="item.status === cvmStatusFilter.CvmStatusDeploymentFailed"
                  type="danger"
                  @click.stop="deleteImportChildNode('delete', item)"
                >
                  {{ $t('computingCluster.resource.delete') }}
                </el-button>
                <!--销毁节点按钮-->
                <el-button
                  class="form-button base-margin__left-0"
                  v-if="item.status === cvmStatusFilter.CvmStatusDeploymentFailed"
                  @click.stop="deleteImportChildNode('terminate', item)"
                >
                  {{ $t('common.terminate') }}
                </el-button>
                <!-- 导入节点 重新导入 -->
                <el-button
                  v-if="item.status === cvmStatusFilter.CvmStatusDeploymentFailed"
                  class="form-button base-margin__left-0"
                  type="primary"
                  @click.stop="importChildNode"
                >
                  {{ $t('computingCluster.resource.reimport') }}
                </el-button>
              </div>
            </template>
          </div>
          <!-- 分页器 -->
          <div class="overview-wrapper-pagination">
            <el-pagination
              v-if="tableDataTotal > 10"
              :current-page="pageIndex"
              :page-size="10"
              :page-sizes="[10, 20, 50, 100]"
              :total="tableDataTotal"
              align="right"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="onCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>

      <div v-else class="overview table" v-bind:class="{ 'v-cloak': true }">
        <el-table
          :data="projectInstanceList"
          class="base-width_fullscreen"
          height="100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('computingCluster.resource.type')" min-width="48px">
            <template slot-scope="scope">
              <span v-if="scope.row.nodeType === 'master'">{{ $t('computingCluster.resource.masterNode') }}</span>
              <span v-else>{{
                scope.row.nodeType === 'login'
                  ? $t('computingCluster.resource.loginNode')
                  : $t('computingCluster.resource.computeNode')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="实例ID/hostName" min-width="80px">
            <template slot-scope="scope">
              <span>
                <p>
                  <span>{{ scope.row.instanceId || '-' }}</span>
                </p>
                <p v-if="scope.row.instanceId !== scope.row.hostname">
                  <span>{{ scope.row.hostname || '-' }}</span>
                </p>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="主IPv4地址" min-width="80px" prop="instancePrivateIp">
            <template slot-scope="scope">
              <span>
                <p>
                  <span>公: {{ scope.row.instancePublicIp || '-' }}</span>
                </p>
                <p>
                  <span>私: {{ scope.row.instancePrivateIp || '-' }}</span>
                </p>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('computingCluster.resource.tags')" min-width="80px" prop="tags">
            <template slot-scope="scope">
              <el-tag v-for="list in scope.row.tags" :key="list.id" size="mini">{{ list }}</el-tag>
              <span v-if="!scope.row.tags || scope.row.tags.length === 0">-</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('computingCluster.resource.status')" min-width="48px">
            <template slot-scope="scope">
              <span
                :class="`${statusFilter(scope.row.status).class}`"
                :style="`color:${statusFilter(scope.row.status).color};`"
              >
                {{ statusFilter(scope.row.status).status }}
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('computingCluster.resource.specification')" min-width="80px">
            <template slot-scope="scope">
              <span>
                <el-tooltip placement="top">
                  <div slot="content">
                    {{ scope.row.cpu }}核 {{ scope.row.memory }}GiB
                    <span v-if="scope.row.gpu !== 0">[{{ scope.row.gpu }} * {{ scope.row.gpuType }}]</span>
                    <br />
                    系统盘:{{ scope.row.diskSize }}GiB {{ filterDiskType(scope.row.diskType) }}
                  </div>
                  <span class="base-cursor__pointer">{{ scope.row.instanceType }}</span>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
          <!--<el-table-column :label="$t('computingCluster.resource.vCPU')" min-width="48px">-->
          <!--  <template slot-scope="scope"> {{ scope.row.cpu }}{{ $t('computingCluster.resource.core') }}</template>-->
          <!--</el-table-column>-->
          <!--<el-table-column :label="$t('computingCluster.resource.vGPU')" min-width="48px">-->
          <!--  <template slot-scope="scope"> {{ scope.row.gpu }}{{ $t('computingCluster.resource.card') }}</template>-->
          <!--</el-table-column>-->
          <el-table-column :label="$t('computingCluster.resource.queue')" min-width="80px">
            <template slot-scope="scope">
              {{ scope.row.queueName || '_' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('computingCluster.resource.platform')" prop="osName"></el-table-column>
          <el-table-column :label="$t('computingCluster.resource.billingMethod')" min-width="50px">
            <template slot-scope="scope">
              <span>{{
                scope.row.instanceChargeType === 'POSTPAID_BY_HOUR'
                  ? $t('computingCluster.resource.postpaid')
                  : scope.row.instanceChargeType === 'PREPAID'
                  ? $t('computingCluster.resource.prepaid')
                  : $t('computingCluster.resource.spotpaid')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('computingCluster.resource.createTime')">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('computingCluster.resource.operation')" width="300">
            <template slot-scope="scope">
              <div class="base-flex">
                <el-button link type="text" @click="openDetails(scope.row)"
                  >{{ $t('computingCluster.resource.details') }}
                </el-button>
                <!-- 管理节点 -->
                <template v-if="scope.row.nodeType === 'master'">
                  <div v-if="isOwner === 1 || (isOwner === 0 && noLoginMaster)">
                    <el-dropdown
                      v-if="scope.row.status === cvmStatusFilter.CvmStatusNormal"
                      class="base-margin__left-8"
                    >
                      <el-button type="text" @click.stop="">
                        {{ $t('computingCluster.resource.login') }}
                        <i class="el-icon-arrow-down"></i>
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="common">
                          <p
                            v-if="filterNodeShow('masterLogin')"
                            class="base-cursor__pointer"
                            @click.stop="startNode(scope.row.instanceId, 'common', scope.row.nodeType)"
                          >
                            {{ $t('computingCluster.resource.login') }}
                          </p>
                        </el-dropdown-item>
                        <el-dropdown-item v-if="filterNodeShow('adminLogin')" command="root">
                          <p
                            class="base-cursor__pointer"
                            @click.stop="startNode(scope.row.instanceId, 'root', scope.row.nodeType)"
                          >
                            {{ $t('computingCluster.resource.adminLogin') }}
                          </p>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="filterNodeShow('masterRestartVNC')"
                          :disabled="scope.row.status !== cvmStatusFilter.CvmStatusNormal"
                        >
                          <p class="base-cursor__pointer" @click.stop="restartVNC(scope.row.instanceId)">
                            {{ $t('computingCluster.resource.restartVNC') }}
                          </p>
                        </el-dropdown-item>
                        <!-- 创建镜像 -->
                        <el-dropdown-item
                          v-if="filterNodeShow('masterCreateImages')"
                          :disabled="scope.row.status !== cvmStatusFilter.CvmStatusNormal"
                          command="createImages"
                        >
                          <p class="base-cursor__pointer" @click.stop="createImages(scope.row)">
                            {{ $t('computingCluster.resource.createImages') }}
                          </p>
                        </el-dropdown-item>
                        <el-dropdown-item command="update">
                          <p class="base-cursor__pointer" @click.stop="updateEdactld">
                            {{ $t('common.update') }}
                          </p>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                  <!--释放实例按钮组件-->
                  <el-button
                    v-if="
                      (scope.row.status === cvmStatusFilter.CvmStatusNormal ||
                        scope.row.status === cvmStatusFilter.CvmStatusInDeployment) &&
                      (isOwner === 1 || (isOwner === 0 && noLoginMaster))
                    "
                    :disabled="projectInstanceList.length > 1"
                    class="base-margin__left-8"
                    link
                    type="text"
                    @click="releaseInstance(scope.row.id, 'master')"
                  >
                    {{ $t('computingCluster.resource.release') }}
                  </el-button>
                  <!--重新创建按钮-->
                  <el-button
                    v-if="
                      scope.row.status === cvmStatusFilter.CvmStatusDestruction ||
                      (scope.row.status === cvmStatusFilter.CvmStatusAbnormal && isOwner === 1)
                    "
                    class="base-margin__left-8"
                    :disabled="isOwner === 0"
                    link
                    type="text"
                    @click="recreate(scope.row)"
                  >
                    {{ $t('computingCluster.resource.recreate') }}
                  </el-button>
                  <!--导入管理节点-->
                  <el-button
                    v-if="
                      scope.row.status === cvmStatusFilter.CvmStatusDestruction ||
                      (scope.row.status === cvmStatusFilter.CvmStatusAbnormal && isOwner === 1)
                    "
                    :disabled="isOwner === 0"
                    link
                    type="text"
                    @click="importMasterNode"
                  >
                    {{ $t('computingCluster.resource.importMasterNode') }}
                  </el-button>
                </template>
                <!-- 计算节点 -->
                <template v-else>
                  <el-dropdown
                    v-if="scope.row.status === cvmStatusFilter.CvmStatusNormal && scope.row.nodeType === 'login'"
                    class="base-margin__left-8"
                    @common.stop="startNode(scope.row.instanceId, 'common', scope.row.nodeType)"
                  >
                    <el-button type="text" @click.stop="">
                      {{ $t('computingCluster.resource.login') }}
                      <i class="el-icon-arrow-down"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="common">
                        <p
                          class="base-cursor__pointer"
                          @click.stop="startNode(scope.row.instanceId, 'common', scope.row.nodeType)"
                        >
                          {{ $t('computingCluster.resource.login') }}
                        </p>
                      </el-dropdown-item>
                      <el-dropdown-item
                        v-if="projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1"
                        :disabled="scope.row.status !== cvmStatusFilter.CvmStatusNormal"
                      >
                        <p class="base-cursor__pointer" @click.stop="restartVNC(scope.row.instanceId)">
                          {{ $t('computingCluster.resource.restartVNC') }}
                        </p>
                      </el-dropdown-item>
                      <!-- 创建镜像 -->
                      <el-dropdown-item
                        v-if="filterNodeShow('childCreateImages')"
                        :disabled="scope.row.status !== cvmStatusFilter.CvmStatusNormal"
                        command="createImages"
                      >
                        <p class="base-cursor__pointer" @click.stop="createImages(scope.row)">
                          {{ $t('computingCluster.resource.createImages') }}
                        </p>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <!--释放实例按钮组件-->
                  <el-button
                    v-if="
                      scope.row.status === cvmStatusFilter.CvmStatusNormal ||
                      scope.row.status === cvmStatusFilter.CvmStatusInDeployment
                    "
                    :label="$t('computingCluster.resource.billingMethod')"
                    class="base-margin__left-8"
                    type="text"
                    @click="releaseInstance(scope.row.id, 'child')"
                  >
                    {{ $t('computingCluster.resource.release') }}
                  </el-button>
                  <!-- 删除按钮 -->
                  <el-button
                    v-if="
                      scope.row.status === cvmStatusFilter.CvmStatusDestruction ||
                      scope.row.status === cvmStatusFilter.CvmStatusAbnormal
                    "
                    type="text"
                    @click="deleteNode(scope.row.id)"
                  >
                    {{ $t('computingCluster.resource.delete') }}
                  </el-button>

                  <!-- 导入节点 重新导入 -->
                  <el-button
                    v-if="scope.row.status === cvmStatusFilter.CvmStatusDeploymentFailed"
                    type="text"
                    @click.stop="importChildNode"
                  >
                    {{ $t('computingCluster.resource.reimport') }}
                  </el-button>

                  <!--删除节点按钮-->
                  <el-button
                    v-if="scope.row.status === cvmStatusFilter.CvmStatusDeploymentFailed"
                    type="text"
                    @click.stop="deleteImportChildNode('delete', scope.row)"
                  >
                    {{ $t('computingCluster.resource.delete') }}
                  </el-button>

                  <!--销毁节点按钮-->
                  <el-button
                    v-if="scope.row.status === cvmStatusFilter.CvmStatusDeploymentFailed"
                    type="text"
                    @click.stop="deleteImportChildNode('terminate', scope.row)"
                  >
                    {{ $t('common.terminate') }}
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <el-pagination
          :current-page="pageIndex"
          :page-size="10"
          :page-sizes="[10, 20, 50, 100]"
          :total="tableDataTotal"
          align="right"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="onCurrentChange"
        >
        </el-pagination>
      </div>

      <!-- 创建节点弹窗 -->
      <el-dialog
        :close-on-click-modal="false"
        :destroy-on-close="true"
        :title="
          this.isCreateAdminNode
            ? $t('computingCluster.resource.createMasterNode')
            : $t('computingCluster.resource.createChildNode')
        "
        :visible.sync="dialogSelectModelVisible"
        width="730px"
        @close="clearFromData"
      >
        <createNode
          ref="createDialog"
          :clickCreateDialog="clickCreateDialog"
          :closeDialog="closeDialog"
          :closeLoading="closeLoading"
          :getResourceList="getResourceList"
          :isDoneDisabled="isDoneDisabled"
          dialogType="createNode"
        ></createNode>
        <template #footer>
          <el-button @click="clearFromData()">{{ $t('computingCluster.resource.cancel') }}</el-button>
          <el-button v-if="!isCreateAdminNode" :disabled="doneDisabled" :loading="loading" @click="affirm(true)">{{
            $t('customCluster.addInstanceDialog.validateParams')
          }}</el-button>
          <el-button :disabled="doneDisabled" :loading="loading" type="primary" @click="affirm(false)">
            {{ $t('computingCluster.resource.confirm') }}
          </el-button>
        </template>
      </el-dialog>
      <!--  激活授权码   -->
      <el-dialog
        :title="$t('computingCluster.resource.generateLicense')"
        :visible.sync="activationCodeVisible"
        width="500px"
      >
        <el-form ref="formLabelAlign" :model="formLabelAlign" label-width="90px">
          <el-form-item :label="$t('computingCluster.resource.softwareAuthorization')">
            <el-select
              v-model="formLabelAlign.applicationId"
              :placeholder="$t('computingCluster.resource.softwareAuthManagement')"
            >
              <el-option
                v-for="item in describeApplicationsList"
                :key="item.applicationInfo.id"
                :label="item.applicationInfo.name"
                :value="item.applicationInfo.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button type="primary" @click="activationLicense"
            >{{ $t('computingCluster.resource.generate') }}
          </el-button>
        </template>
      </el-dialog>
      <!--  创建镜像   -->
      <el-dialog
        :close-on-click-modal="false"
        :title="$t('computingCluster.resource.createImage')"
        :visible.sync="createImagesVisible"
        width="600px"
      >
        <div>
          <el-form ref="createImagesForm" label-width="120px">
            <el-form-item :label="$t('computingCluster.resource.imagesName')">
              <el-input
                v-model="imagesForm.imageName"
                :placeholder="$t('computingCluster.resource.inputImagesName')"
                maxlength="60"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('computingCluster.resource.imagesDescription')">
              <el-input
                v-model="imagesForm.imageDescription"
                :placeholder="$t('computingCluster.resource.inputImagesDescription')"
                :rows="4"
                maxlength="250"
                show-word-limit
                type="textarea"
              ></el-input>
            </el-form-item>
            <!--<el-form-item label="强制关机">-->
            <!--  <el-radio v-model="imagesForm.forcePoweroff"></el-radio>-->
            <!--</el-form-item>-->
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            :disabled="imagesForm.imageName === '' || createImagesLoading"
            :loading="testImagesLoading"
            @click="testCreateImages(true)"
          >
            {{ $t('customCluster.addInstanceDialog.validateParams') }}
          </el-button>
          <el-button
            :disabled="imagesForm.imageName === '' || testImagesLoading"
            :loading="createImagesLoading"
            type="primary"
            @click="doneCreateImages(false)"
            >{{ $t('computingCluster.resource.confirm') }}</el-button
          >
        </span>
      </el-dialog>

      <!--  导入管理节点   -->
      <el-dialog
        :close-on-click-modal="false"
        :title="$t('computingCluster.resource.importMasterNode')"
        :visible.sync="importMasterNodeVisible"
        width="600px"
      >
        <div>
          <el-form
            label-position="left"
            ref="importMasterNodeForm"
            v-loading="importMasterNodeFormLoading"
            label-width="100px"
          >
            <!-- 地域选择表单项 -->
            <el-form-item :label="$t('createNode.region')">
              <el-select
                v-model="importMasterNodeForm.region"
                :placeholder="$t('createNode.selectMachineRegion')"
                @change="getProjectEnvInfo"
              >
                <!-- 遍历地域选项 -->
                <el-option v-for="item in regionList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>

            <!-- 集群环境选择表单项（仅管理员节点可见） -->
            <el-form-item :label="$t('createNode.clusterEnv')" class="select-width" filterable>
              <el-select
                v-model="importMasterNodeForm.projectEnvId"
                :placeholder="$t('createNode.selectClusterEnvInfo')"
                filterable
                @change="getInstanceList"
              >
                <!-- 遍历环境列表选项 -->
                <el-option v-for="item in envList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <!--实例选择 -->
            <el-form-item :label="$t('computingCluster.resource.instance')" prop="cloudInstanceId">
              <div class="base-flex base-width_fullscreen">
                <el-select
                  v-model="importMasterNodeForm.cloudInstanceId"
                  :placeholder="$t('computingCluster.resource.selectInstanceToImport')"
                  filterable
                  class="base-flex__1"
                >
                  <el-option
                    v-for="item in instanceList"
                    :key="item.InstanceId"
                    :label="`${item.InstanceName} | ${item.InstanceId}`"
                    :value="item.InstanceId"
                  />
                </el-select>
                <div class="base-margin__left-10">
                  <i
                    class="base-color__light_blue base-font-size__16px base-cursor__pointer el-icon-refresh"
                    @click="getInstanceList"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importMasterNodeVisible = false">{{ $t('computingCluster.resource.cancel') }}</el-button>
          <el-button :loading="importMasterNodeFormLoading" type="primary" @click="doneImportMasterNode"
            >{{ $t('computingCluster.resource.confirm') }}
          </el-button>
        </span>
      </el-dialog>

      <!--  导入子节点   -->
      <el-dialog
        :close-on-click-modal="false"
        :title="$t('computingCluster.resource.importChildNode')"
        :visible.sync="importChildNodeVisible"
        width="600px"
      >
        <div>
          <el-form
            ref="importChildNodeForm"
            label-position="left"
            v-loading="importChildNodeFormLoading"
            label-width="120px"
          >
            <!-- 地域选择表单项 -->
            <el-form-item :label="$t('createNode.region')">
              <el-select
                disabled
                v-model="importChildNodeForm.region"
                :placeholder="$t('createNode.selectMachineRegion')"
              >
                <!-- 遍历地域选项 -->
                <el-option v-for="item in regionList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>

            <!-- 镜像选择表单项 -->
            <el-form-item :label="$t('createNode.image')" prop="imageId">
              <div class="base-width_fullscreen">
                <div class="base-flex base-margin__bottom-10">
                  <el-select
                    v-model="importChildNodeForm.imageType"
                    :placeholder="$t('createNode.selectImageType')"
                    class="formItem__select-short base-margin__right-20"
                    @change="changeImageType('imageType')"
                  >
                    <el-option :label="$t('createNode.sharedImages')" value="SHARED_IMAGE"></el-option>
                    <el-option :label="$t('createNode.privateImages')" value="PRIVATE_IMAGE"></el-option>
                  </el-select>
                  <el-select
                    v-model="importChildNodeForm.imagePlatformType"
                    :placeholder="$t('createNode.selectImageType')"
                    class="formItem__select-short base-margin__right-20"
                    @change="changeImageType('imagePlatform')"
                  >
                    <el-option
                      v-for="item in imageTypeList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
                <el-select
                  v-model="importChildNodeForm.imageId"
                  :placeholder="$t('createNode.selectImage')"
                  class="select-width"
                  filterable
                >
                  <!-- 遍历镜像选项 -->
                  <el-option
                    v-for="item in imageOption"
                    :key="item.value"
                    :label="`${item.text} | ${item.value}`"
                    :value="item.value"
                  >
                    <el-tooltip
                      class="item"
                      :open-delay="100"
                      effect="dark"
                      content="Top Center 提示文字"
                      placement="bottom"
                    >
                      <template slot="content">
                        <span>
                          <p>镜像名称: {{ item.text }}</p>
                          <p>镜像ID: {{ item.value }}</p>
                          <p>系统盘容量: {{ item.size }}GiB</p>
                          <p>操作系统: {{ item.osName }}</p>
                        </span>
                      </template>
                      <span>{{ item.text }} | {{ item.value }}</span>
                    </el-tooltip>
                  </el-option>
                </el-select>
              </div>
            </el-form-item>

            <!-- 子节点类型选择表单项（非管理员节点可见） -->
            <el-form-item :label="$t('createNode.childNodeType')" prop="nodeType">
              <el-select
                v-model="importChildNodeForm.nodeType"
                :placeholder="$t('createNode.selectNodeType')"
                class="select-width"
              >
                <!-- 遍历节点类型选项 -->
                <el-option
                  v-for="item in importChildNodeTypeList"
                  :key="item.value"
                  :disabled="item.disabled"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>

            <!-- 队列表单项（非管理员节点可见） -->
            <el-form-item :label="$t('createNode.queue')" prop="queueName">
              <el-autocomplete
                v-model="importChildNodeForm.queueName"
                :fetch-suggestions="autocompleteQuerySearch"
                :placeholder="$t('createNode.inputContent')"
                class="select-width"
              />
            </el-form-item>

            <!-- 登录方式表单项（Windows类型可见） -->
            <el-form-item :label="$t('createNode.loginMethod')">
              <el-radio-group v-model="passwordRadio" @input="checkPasswordRadio">
                <el-radio :label="false">{{ $t('createNode.setPassword') }}</el-radio>
                <el-radio :label="true">{{ $t('createNode.associateKeyImmediately') }}</el-radio>
              </el-radio-group>

              <!-- 密码设置区域 -->
              <div v-if="!displayPasswordType">
                <div class="base-margin__bottom-20">
                  <span class="base-margin__right-20">
                    {{ $t('createNode.password') }}
                    <el-popover placement="top-start" trigger="hover" width="330">
                      <div class="tips">
                        <p>{{ $t('createNode.passwordTip1') }}</p>
                        <p>{{ $t('createNode.passwordTip2') }}</p>
                        <p>{{ $t('createNode.passwordTip3') }}</p>
                        <p>{{ $t('createNode.passwordTip4') }}</p>
                        <p class="base-margin__left-20">{{ $t('createNode.lowercaseLetters') }}</p>
                        <p class="base-margin__left-20">{{ $t('createNode.uppercaseLetters') }}</p>
                        <p class="base-margin__left-20">{{ $t('createNode.numbers') }}</p>
                        <p class="base-margin__left-20" v-text="'~!@#$%^&*-+=/'"></p>
                      </div>
                      <el-icon slot="reference" class="el-icon-question">hover {{ $t('createNode.activate') }}</el-icon>
                    </el-popover>
                  </span>
                  <el-input v-model="password" class="base-width__240" show-password type="password" />
                  <el-button class="base-margin__left-10" type="primary" @click="randomPassword">
                    {{ $t('createNode.randomPassword') }}
                  </el-button>
                </div>
                <div class="base-margin__bottom-20">
                  <span class="base-margin__right-8">
                    {{ $t('createNode.confirmPassword') }}
                  </span>
                  <el-input v-model="nextPassword" class="base-width__240" show-password type="password" />
                </div>
              </div>

              <!-- 密钥关联区域 -->
              <div v-else>
                <el-select
                  v-model="describeKeyPairsData"
                  :placeholder="$t('createNode.selectKey')"
                  class="select-width"
                  collapse-tags
                  multiple
                >
                  <el-option
                    v-for="item in describeKeyPairsList"
                    :key="item.KeyId"
                    :label="item.KeyName"
                    :value="item.KeyId"
                  />
                </el-select>
              </div>
            </el-form-item>

            <!--实例选择 -->
            <el-form-item
              class="base-margin__right-10"
              :label="$t('computingCluster.resource.instance')"
              prop="cloudInstanceId"
            >
              <div class="base-flex base-width_fullscreen">
                <el-select
                  v-model="importChildNodeForm.cloudInstanceId"
                  :placeholder="$t('computingCluster.resource.selectInstanceToImport')"
                  class="base-margin__right-10"
                  filterable
                  multiple
                >
                  <el-option
                    v-for="item in instanceList"
                    :key="item.InstanceId"
                    :label="`${item.InstanceName} | ${item.InstanceId}`"
                    :value="item.InstanceId"
                  />
                </el-select>
                <div class="base-margin__left-10">
                  <i
                    class="base-color__light_blue base-font-size__16px base-cursor__pointer el-icon-refresh"
                    @click="getChildInstanceList"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importChildNodeVisible = false">{{ $t('computingCluster.resource.cancel') }}</el-button>
          <el-button :loading="importChildNodeFormLoading" type="primary" @click="doneImportChildNode"
            >{{ $t('computingCluster.resource.confirm') }}
          </el-button>
        </span>
      </el-dialog>

      <!--清空节点数据 创建节点过程 步骤 -->
      <MasterNodeAction ref="masterNodeAction" />

      <!--节点详情-->
      <NodeDetails ref="nodeDetails" @upDateTags="upDateTags" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { use } from '@tencent/tea-sdk-runner';
import { getRequest, postRequest } from '@/common/libs/request';
import createNode from '@/components/createNodeDialog/index.vue';
import ExamineAKSK from '@/components/examineAKSK/index.vue';
import NodeDetails from '@/components/nodeDetails/index.vue';
import MasterNodeAction from '@/components/masterNodeAction/index.vue';
import {
  BillingTypeDataList,
  CvmStatusFilter,
  CvmStatusFilterList,
  ENV_STATUS_FAIL,
  NodeTypeFilterList,
  projectEnvStatusCleared,
  projectEnvStatusClearing,
  projectEnvStatusTerminated,
} from '@/common/constants';
import { Message } from 'element-ui';
import { debounce, exportData, filterDiskType, regionList } from '@/common/utils/utils';
import Cookies from 'js-cookie';
import { setupMfaSdk } from '@/common/libs/setupMfaSdk';
import { UTIL } from '@/common/utils';

export default {
  name: 'resource',
  components: {
    createNode,
    ExamineAKSK,
    NodeDetails,
    MasterNodeAction,
  },
  data() {
    return {
      isNotMaster: false, // 是否不是主节点
      changeDataViewType: false, // 视图类型切换标志
      isOwner: 0, // 是否为管理员
      isCreateAdminNode: false, // 是否为管理节点
      timeout: null, // 定时器
      loading: false, // 创建节点确认按钮loading状态
      form: {}, // 表单数据
      projectId: 0, // 项目ID
      userId: '', // 用户ID
      projectInstanceList: [], // 实例列表数据
      dialogSelectModelVisible: false, // 创建节点弹窗可见性
      test: true, // 测试标志
      cvmStatusFilter: CvmStatusFilter, // 状态过滤器
      activationCodeVisible: false, // 授权码激活弹窗可见性
      describeApplicationsList: [], // 应用列表
      formLabelAlign: {
        // 表单对齐数据
        applicationId: '',
      },
      deployModeSimple: false, // 部署模式
      noLoginMaster: false, // 无登录主节点
      doneDisabled: true, // 完成按钮禁用状态
      projectInstanceListLoading: false, // 实例列表加载状态
      currentProject: null, // 当前项目
      projectEnvStatusCleared, // 环境状态-已清除
      projectEnvStatusTerminated, // 环境状态-已终止
      projectEnvStatusClearing,
      ENV_STATUS_FAIL,
      examineAKSKVisible: false,
      loginType: sessionStorage.getItem('loginType'),
      clusterNodeId: 0,
      terminateInstancesType: 'master',
      mfaSdk: null, // MFA SDK
      pageIndex: 1, // 分页index
      pageLimit: 10, // 每一页条数
      tableDataTotal: 0, // 任务总数
      handleSelectionChangeData: [],
      currentPage: 1,
      statusList: [], // 筛选状态列表
      CvmStatusFilterList, // 状态列表
      queueNameList: [], // 筛选队列列表
      queueNameFilterList: [], // 队列名称列表
      nodeTypeList: [], // 筛选节点类型列表
      NodeTypeFilterList, // 节点类型列表
      instancechargeTypeList: [], // 筛选计费类型列表
      BillingTypeDataList, // 计费类型列表
      clusterNodeCount: 0, // 集群节点数量
      // 视图类型切换标志
      isChangeDataViewType: false,
      createImagesVisible: false, // 创建镜像弹窗可见性
      // 创建镜像表单数据
      imagesForm: {
        imageName: '',
        instanceId: '',
        region: '',
        imageDescription: '',
        forcePoweroff: 'false',
        dryRun: false,
      },
      createImagesLoading: false, // 创建镜像确认按钮loading状态
      testImagesLoading: false, // 测试镜像确认按钮loading状态
      masterNodeInfo: {}, // 主节点信息
      importMasterNodeVisible: false, // 导入主节点弹窗可见性
      importMasterNodeFormLoading: false, // 导入主节点确认按钮loading状态
      regionList, // 地域列表
      envList: [], // 环境列表
      instanceList: [], // 实例列表
      importMasterNodeForm: {
        projectEnvId: '',
        region: '',
        cloudInstanceId: '',
      },
      importChildNodeVisible: false, // 导入子节点弹窗可见性
      importChildNodeFormLoading: false, // 导入子节点确认按钮loading状态
      importChildNodeForm: {
        region: '',
        cloudInstanceId: [],
        imageType: 'SHARED_IMAGE',
        imagePlatformType: '',
        imageId: '',
        imagePlatform: '',
        nodeType: 'worker',
        queueName: 'login',
      }, // 导入子节点表单数据

      imageOptionList: [], // 总的镜像选项
      imageOption: [], // 镜像选项
      imageTypeList: [], // 镜像类型列表
      importChildNodeTypeList: [
        { text: this.$t('createNode.loginNode'), value: 'login', disabled: false },
        { text: this.$t('createNode.workerNode'), value: 'worker', disabled: false },
      ], // 导入子节点类型列表
      queueList: [], // 队列列表
      passwordRadio: false, // 密码单选状态
      displayPasswordType: false, // 显示密码类型
      describeKeyPairsData: [], // 密钥对数据
      describeKeyPairsList: [], // 密钥对列表
      password: '', // 密码
      nextPassword: '', // 确认密码
      windowsType: false, // 是否为windows类型
      selectInstanceId: '', // 筛选实例ID
      selectInstancePrivateIp: '', // 筛选实例内网IP
      filterDiskType, // 筛选磁盘类型
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      this.isOwner = val.isOwner || 0;
      if (currentProject.id !== this.projectId) {
        this.projectId = val.id;
        this.resetPagination();
        this.getResourceList();
      }
    },
    'app.createMasterNode'() {
      const currentProject = this.getCurrentProject();
      this.projectId = currentProject.id;
      this.resetPagination();
      this.getResourceList();
    },
  },
  methods: {
    /**
     * 导出节点Excel
     **/
    exportNodeExcel() {
      this.$message.warning('导出数据中，请稍后');
      const result = this.handleSelectionChangeData.map(item => ({
        实例ID: item.instanceId || '-',
        私有IP: item.instancePrivateIp || '-',
        主机名: item.hostname || '-',
        节点类型: item.nodeType || '-',
        队列: item.queueName || '-',
      }));
      // private_ip, hostname ,instance_id, node_type, queue
      exportData(result, '计算集群列表');
    },

    /**
     * 删除导入子节点
     **/
    deleteImportChildNode(type, item) {
      if (type === 'delete') {
        this.deleteNode(item.id);
      } else {
        this.releaseInstance(item.id, 'child');
      }
    },

    /**
     * 导入子节点
     **/
    importChildNode() {
      this.windowsType = this.masterNodeInfo.imagePlatform === 'windows';
      this.passwordRadio = false; // 密码单选状态
      this.password = '';
      this.nextPassword = '';
      this.describeKeyPairsList = [];
      this.describeKeyPairsData = [];
      this.getImageList();
      this.getCommonData();

      this.importChildNodeForm = {
        region: this.masterNodeInfo.region,
        cloudInstanceId: [],
        imageType: 'SHARED_IMAGE',
        imagePlatformType: '',
        imageId: '',
        imagePlatform: '',
        nodeType: 'worker',
        queueName: 'cpuq',
      };
      this.getChildInstanceList();
      this.importChildNodeVisible = true;
    },

    /**
     * 导入子节点 确认
     **/
    async doneImportChildNode() {
      if (this.importChildNodeForm.imageId === '') {
        this.$message.warning(this.$t('createNode.selectImage'));
        return false;
      }

      if (this.importChildNodeForm.cloudInstanceId.length === 0) {
        this.$message.warning(this.$t('computingCluster.resource.selectInstanceToImport'));
        return false;
      }

      if (!this.windowsType) {
        // 密钥模式处理
        if (this.passwordRadio) {
          if (this.describeKeyPairsData.length === 0) {
            this.$message.warning(this.$t('createNode.selectKey'));
            return false;
          }
        } else {
          // 密码模式处理
          // 验证密码格式
          if (!this.validPassword(this.password)) {
            return false;
          }
        }
      }

      if (this.importChildNodeForm.nodeType === 'login') {
        for (let i = 0; i < this.importChildNodeForm.cloudInstanceId.length; i++) {
          const item = this.importChildNodeForm.cloudInstanceId[i];

          const publicIpAddresses = this.instanceList.find(env => env.InstanceId === item)?.PublicIpAddresses || [];

          if (publicIpAddresses.length === 0) {
            Message.error('导入实例未开启公网IP,暂不支持导入为登录节点，请重新选择实例！');
            return;
          }
        }
      }

      const params = {
        ...this.importChildNodeForm,
        password: this.password === '' ? '' : UTIL.rsaEncryption(this.password),
        keypairIds: this.describeKeyPairsData.length === 0 ? [] : this.describeKeyPairsData,
      };

      if (this.loginType === 'qq') {
        postRequest('/api/eda/common/cluster/importClusterNodes', params).then(() => {
          this.$message.success(this.$t('computingCluster.resource.importChildNodeSuccess'));
          this.importChildNodeVisible = false;
          this.getResourceList();
        });
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk.verify({ api: 'cvm:ResetInstance' }).then(() => {
            // 展示确认弹窗
            postRequest('/api/eda/common/cluster/importClusterNodes', params).then(() => {
              this.$message.success(this.$t('computingCluster.resource.importChildNodeSuccess'));
              this.importChildNodeVisible = false;
              this.getResourceList();
            });
          });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('computingCluster.resource.mfaAuthFailed'),
          });
        }
      }
    },

    /**
     * 验证密码
     * @param {String} pwd 密码
     * @returns {Boolean} 是否有效
     */
    validPassword(pwd) {
      if (pwd.length < 12 || pwd.length > 30) {
        this.$message.warning(this.$t('createNode.passwordLengthError'));
        this.loading = false;
        this.closeLoading();
        return false;
      }
      if (pwd.includes(' ')) {
        this.$message.warning(this.$t('createNode.passwordNoSpace'));
        this.loading = false;
        this.closeLoading();
        return false;
      }
      if (this.password !== this.nextPassword) {
        Message.warning(this.$t('createNode.passwordNotMatch'));
        this.loading = false;
        this.closeLoading();
        return false;
      }

      if (pwd.startsWith('/')) {
        this.$message.warning(this.$t('createNode.passwordNoSlash'));
        this.loading = false;
        this.closeLoading();
        return false;
      }

      // 密码必须包含至少三种字符类型
      let hasLower = 0;
      let hasUpper = 0;
      let hasDigit = 0;
      let hasSpecial = 0;

      for (let i = 0; i < pwd.length; i++) {
        const char = pwd[i];
        if (char >= 'a' && char <= 'z') {
          hasLower = 1;
        } else if (char >= 'A' && char <= 'Z') {
          hasUpper = 1;
        } else if (char >= '0' && char <= '9') {
          hasDigit = 1;
        } else if ('()`~!@#$%^&*-+=_|{}[]:;\\\'<>,.?/'.includes(char)) {
          hasSpecial = 1;
        } else {
          this.$message.warning(this.$t('createNode.passwordInvalidChars'));
          return false;
        }
      }

      if (hasLower + hasUpper + hasDigit + hasSpecial < 3) {
        this.$message.warning(this.$t('createNode.passwordRequirement'));
        return false;
      }

      return true;
    },

    /**
     * 获取子节点实例列表
     **/
    getChildInstanceList() {
      this.importChildNodeFormLoading = true;
      const params = {
        region: this.importChildNodeForm.region,
        offset: 0,
        filters: [
          {
            Name: 'vpc-id',
            Values: [this.masterNodeInfo.vpcId],
          },
        ],
        limit: 100,
      };
      postRequest('/api/eda/common/tencentcloud/describeInstances', params)
        .then((res) => {
          // 处理实例列表数据
          this.instanceList = res.instanceList || [];
          this.importChildNodeFormLoading = false;
        })
        .catch(() => {
          this.importChildNodeFormLoading = false;
        });
    },

    /**
     * 检查密码单选
     * @param {Boolean} val 值
     */
    checkPasswordRadio(val) {
      if (val === true) {
        this.displayPasswordType = true;
        this.password = '';
        this.nextPassword = '';
      }
      if (val === false) {
        this.describeKeyPairsData = [];
        this.displayPasswordType = false;
      }
    },

    /**
     * 生成随机密码
     */
    randomPassword() {
      const lowerCase = 'abcdefghijklmnopqrstuvwxyz';
      const upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      const numbers = '0123456789';
      const specialChars = '~!@#$%^&*-+=/';
      const allChars = lowerCase + upperCase + numbers + specialChars;
      const passwordLength = 12;
      let password = '';
      const charTypes = [false, false, false, false]; // [小写, 大写, 数字, 特殊字符]

      // 确保至少包含三种字符类型
      const ensureTypes = () => {
        const typeIndex = Math.floor(Math.random() * 4);
        switch (typeIndex) {
          case 0:
            password += lowerCase[Math.floor(Math.random() * lowerCase.length)];
            charTypes[0] = true;
            break;
          case 1:
            password += upperCase[Math.floor(Math.random() * upperCase.length)];
            charTypes[1] = true;
            break;
          case 2:
            password += numbers[Math.floor(Math.random() * numbers.length)];
            charTypes[2] = true;
            break;
          case 3:
            password += specialChars[Math.floor(Math.random() * specialChars.length)];
            charTypes[3] = true;
            break;
        }
      };

      // 确保至少包含三种字符类型
      for (let i = 0; i < 3; i++) {
        ensureTypes();
      }

      // 生成剩余的密码字符
      for (let i = password.length; i < passwordLength; i++) {
        password += allChars[Math.floor(Math.random() * allChars.length)];
      }

      // 确保密码不以 '/' 开头
      while (password[0] === '/') {
        password = password.slice(1);
      }

      // 打乱密码字符顺序
      password = password
        .split('')
        .sort(() => Math.random() - 0.5)
        .join('');

      this.password = `t${password}`;
      this.nextPassword = `t${password}`;
    },

    /**
     * 获取通用数据
     */
    getCommonData() {
      // 获取项目全部队列列表
      postRequest('/api/eda/common/cluster/describeQueueList').then((res) => {
        this.queueList = res?.queueList.map(item => ({ value: item }));
      });

      // 获取密钥对列表
      postRequest('/api/eda/common/tencentcloud/describeKeyPairs', {
        limit: 100,
        offset: 0,
      }).then((res) => {
        this.describeKeyPairsList = res?.list || [];
      });
    },

    /**
     * 自动完成查询搜索
     * @param {String} queryString 查询字符串
     * @param {Function} cb 回调函数
     */
    autocompleteQuerySearch(queryString, cb) {
      const restaurants = this.queueList;
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },

    /**
     * 创建过滤器
     * @param {String} queryString 查询字符串
     * @returns {Function} 过滤函数
     */
    createFilter(queryString) {
      return restaurant => restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
    },

    /**
     * 选择镜像类型
     */
    changeImageType(type) {
      this.importChildNodeForm.imageId = '';
      if (type === 'imageType') {
        this.importChildNodeForm.imagePlatformType = '';
        this.getImageList();
      } else {
        if (this.importChildNodeForm.imagePlatformType === '') {
          this.imageOption = this.imageOptionList;
        } else {
          this.imageOption = this.imageOptionList.filter(item => item.platform === this.importChildNodeForm.imagePlatformType);
        }
      }
    },

    /**
     * 获取镜像列表
     */
    getImageList() {
      const param = {
        region: this.masterNodeInfo.region,
        tags: ['openeda:'],
        imageType: this.importChildNodeForm.imageType,
        platformList: '',
      };
      param.platformList = this.masterNodeInfo.imagePlatform === 'windows' ? ['Windows'] : ['CentOS', 'Ubuntu', 'TencentOS'];
      // 当地区为空时，不进行请求
      return postRequest('/api/eda/common/eda/getImageList', param).then((res) => {
        this.imageOptionList = [];
        this.imageOption = [];
        const platformSet = new Set();
        platformSet.add(''); // 添加"全部"选项
        res?.list.forEach((item) => {
          // 当创建管理节点时，展示全部镜像
          // 当创建子节点时则根据管理节点的镜像类型进行过滤
          this.imageOption.push({
            text: item.name,
            value: item.value,
            size: item.disk,
            platform: item.platform,
            osName: item.osName,
          });
          platformSet.add(item.platform);
        });
        this.imageOptionList = this.imageOption;
        this.imageTypeList = Array.from(platformSet).map(platform => ({
          text: platform === '' ? this.$t('common.all') : platform,
          value: platform,
        }));
      });
    },

    /**
     * 判断节点是否展示按钮
     * @param {*} type 节点类型
     **/
    // deployModeSimple 是否为简单部署模式
    // isOwner 是否为项目所有者
    // projectInstanceList 项目实例列表
    // noLoginMaster 普通用户是否可以登录主节点
    filterNodeShow(type) {
      switch (type) {
        case 'masterLogin':
          // 管理员 普通登录
          if (this.projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1) {
            // 简单部署模式下，不展示登录按钮
            if (this.deployModeSimple) {
              return false;
            }
            return this.isOwner === 1 || (this.isOwner === 0 && this.noLoginMaster);
          }
          return this.isOwner === 1 || (this.isOwner === 0 && this.noLoginMaster);

        case 'adminLogin':
          // 管理员 管理登录
          if (this.projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1) {
            if (this.noLoginMaster) {
              return true;
            }
            return this.isOwner === 1;
          }
          return false;

        case 'masterRestartVNC':
          if (this.projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1) {
            if (this.noLoginMaster) {
              return true;
            }
            return this.isOwner === 1;
          }
          return false;

        case 'masterCreateImages':
          if (this.projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1) {
            return this.deployModeSimple;
          }
          if (this.noLoginMaster) {
            return true;
          }
          return this.isOwner === 1;

        case 'childCreateImages':
          if (this.projectInstanceList[0]?.osName.toLowerCase().indexOf('windows') === -1) {
            return this.deployModeSimple;
          }
          return true;
      }
    },

    // 重置分页数据至初始状态
    resetPagination() {
      this.pageIndex = 1;
      this.pageLimit = 10;
      // this.tableDataTotal = 0;
      this.currentPage = 1;
      this.handleSelectionChangeData = [];
    },

    async filterGetResourceList() {
      await this.resetPagination();
      await this.getResourceList();
    },
    /**
     * 批量销毁节点
     * 1. 遍历选中的节点数据
     * 2. 检查节点类型和状态是否符合销毁条件
     * 3. 收集符合条件的节点ID
     * 4. 调用销毁实例的方法
     * 5. 捕获并处理异常
     */
    batchDestruction() {
      const ids = []; // 用于存储要销毁的节点ID
      try {
        // 遍历选中的节点数据
        this.handleSelectionChangeData.forEach((item) => {
          // 检查节点类型，管理节点不支持批量销毁
          if (item.nodeType === 'master') {
            throw new Error(this.$t('computingCluster.resource.masterNodeNotSupportBatchDestroy'));
          }
          // 检查节点状态，创建中不允许销毁
          if (item.status === this.cvmStatusFilter.CvmStatusCreate) {
            throw new Error(this.$t('computingCluster.resource.instanceCreatingNotAllowDestroy'));
          }
          // 检查节点状态，实例销毁中不允许再次销毁
          if (item.status === this.cvmStatusFilter.CvmStatusInDestruction) {
            throw new Error(this.$t('computingCluster.resource.instanceDestroyingNotAllowDestroy'));
          }
          // 将符合条件的节点ID加入数组
          ids.push(item.id);
        });
        // 调用销毁实例的方法，传入节点ID数组和节点类型
        this.releaseInstance(ids, 'child');
      } catch (e) {
        // 捕获异常并显示警告信息
        this.$message.warning(e);
      }
    },

    handleSelectionChange(val) {
      console.log(val, 'valvalval');
      this.handleSelectionChangeData = val;
    },
    /**
     * 分页器钩子函数 页数修改时触发
     * @param val 页数
     */
    onCurrentChange(val) {
      this.pageIndex = val;
      this.getResourceList();
    },

    /**
     * 每页显示数量钩子函数  每页显示数量修改时触发
     */
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getResourceList();
    },
    /**
     * 查看节点详情
     */
    openDetails(data) {
      this.$refs.nodeDetails.openNodeDetails(data);
    },

    /**
     * 更新标签
     */
    upDateTags(value, id) {
      this.projectInstanceList.forEach((item) => {
        if (item.instanceId === id) {
          item.tags = [value];
        }
      });
    },

    /**
     * 打开授权码激活弹窗
     */
    activation() {
      this.activationCodeVisible = true;
      this.getDescribeApplicationsLicense();
      this.formLabelAlign = {
        applicationId: '',
      };
    },

    /**
     * 获取软件授权列表
     */
    getDescribeApplicationsLicense() {
      getRequest('/api/eda/common/eda/describeApplicationsLicense?offset=0&limit=999').then((res) => {
        this.describeApplicationsList = res.list;
      });
    },

    /**
     * 重启vnc
     */
    restartVNC(instanceId) {
      this.$notify({
        title: this.$t('computingCluster.resource.restartVNC'),
        message: this.$t('computingCluster.resource.instanceVNCRestarting', { instanceId }),
        duration: 0,
        type: 'warning',
      });
      postRequest('/api/eda/common/project/reStartUserVNC', {
        instanceId,
      })
        .then(() => {
          this.$notify({
            title: this.$t('computingCluster.resource.restartVNC'),
            message: this.$t('computingCluster.resource.instanceVNCRestartSuccess', { instanceId }),
            duration: 0,
            type: 'success',
          });
        })
        .catch(() => {
          this.$message.error(this.$t('computingCluster.resource.VNCRestartFailed'));
        });
    },

    /**
     * 激活License
     * */
    activationLicense() {
      debounce(() => {
        postRequest('/api/eda/common/eda/createApplicationLicense', {
          ...this.formLabelAlign,
        }).then(() => {
          Message.success(this.$t('computingCluster.resource.generateLicenseSuccess'));
          this.activationCodeVisible = false;
        });
      }, 500);
    },

    /**
     * 状态过滤
     * @param {*} val 节点状态
     */
    statusFilter(val) {
      switch (val) {
        case this.cvmStatusFilter.CvmStatusCreate:
          return { status: this.$t('computingCluster.resource.statusCreate'), class: 'status__color-create' };
        case this.cvmStatusFilter.CvmStatusNormal:
          return { status: this.$t('computingCluster.resource.statusNormal'), class: 'status__color-Normal' };
        case this.cvmStatusFilter.CvmStatusAbnormal:
          return { status: this.$t('computingCluster.resource.statusAbnormal'), class: 'status__color-InDestruction' };
        case this.cvmStatusFilter.CvmStatusInDestruction:
          return {
            status: this.$t('computingCluster.resource.statusInDestruction'),
            class: 'status__color-Destruction',
          };
        case this.cvmStatusFilter.CvmStatusDestruction:
          return { status: this.$t('computingCluster.resource.statusDestruction'), class: 'status__color-Abnormal' };
        case this.cvmStatusFilter.CvmStatusInDeployment:
          return { status: this.$t('computingCluster.resource.statusInDeployment'), class: 'status__color-create' };
        case this.cvmStatusFilter.CvmStatusDeploymentFailed:
          return {
            status: this.$t('computingCluster.resource.statusDeploymentFailed'),
            class: 'status__color-InDestruction',
          };
        default:
          return '';
      }
    },

    /**
     * 节点类型过滤 展示节点类型
     */
    filterNodeName(val) {
      if (val === 'master') return this.$t('computingCluster.resource.masterNode');
      if (val === 'login') return this.$t('computingCluster.resource.loginNode');
      if (val === 'queue') return this.$t('common.constants.queueNode');

      return this.$t('computingCluster.resource.computeNode');
    },

    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.dialogSelectModelVisible = false;
    },

    /**
     * 检查是否录入子账号
     */
    checkProjectTencentAccountExist() {
      // this.$confirm('您已选择关闭超线程功能。此操作需要提前联系腾讯云客服申请白名单权限，否则实例将保持默认超线程设置？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      if (this.loginType === 'qq') {
        postRequest('/api/eda/common/eda/checkProjectTencentAccountExist', {
          isOwner: this.isOwner === 1,
        })
          .then(() => {
            this.$store.commit('app/setTeamIsShow', {
              isShow: true,
              action: 'createTeamInfo',
            });
          })
          .catch(() => {
            // 管理员isOwner = 1
            if (this.isOwner === 1) {
              this.examineAKSKVisible = true;
            }
          });
      } else {
        this.$store.commit('app/setTeamIsShow', {
          isShow: true,
          action: 'createTeamInfo',
        });
      }
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消创建管理节点'
      //   });
      // });
    },

    /**
     * 取消录入aksk弹窗
     */
    examineAKSKVisibleFalse() {
      this.examineAKSKVisible = false;
    },

    /**
     * 关闭确认loading
     */
    closeLoading() {
      this.loading = false;
    },

    /**
     * 清除数据
     */
    clearFromData() {
      this.doneDisabled = true;
      this.$refs.createDialog.closeForm();
    },

    /**
     * 确认创建节点
     * 1. 设置loading状态
     * 2. 调用createNode方法创建节点
     * 3. 创建成功后重置分页并刷新资源列表
     * 4. 创建失败时关闭loading状态
     */
    affirm(dryRun) {
      this.loading = true;
      this.$refs.createDialog
        .createNode(dryRun)
        .then(() => {
          this.resetPagination();
          this.getResourceList();
        })
        .catch(() => {
          this.closeLoading();
          this.loading = false;
        });
    },

    /**
     * 获取节点创建中 信息
     */
    getProjectNodeDeploy(data, item) {
      if (item.status !== this.cvmStatusFilter.CvmStatusCreate || item.nodeType !== 'master') return;
      this.$refs.masterNodeAction.getProjectNodeDeploy(data, this.$t('computingCluster.resource.nodeCreationProcess'));
    },
    /**
     * 是否禁用
     */
    isDoneDisabled(val) {
      this.doneDisabled = val;
    },

    /**
     * 获取资源
     */
    async getResourceList() {
      this.createMasterNodeVisible = false;
      const id = this.projectId;
      const offset = this.pageLimit * (this.pageIndex - 1);
      if (id > 0) {
        this.projectInstanceListLoading = true;
        postRequest('/api/eda/common/cluster/describeClusterNodes', {
          Offset: offset,
          limit: this.pageLimit,
          queueNameList: this.queueNameList,
          nodeTypeList: this.nodeTypeList,
          statusList: this.statusList,
          instancechargeTypeList: this.instancechargeTypeList,
          instanceIds: [this.selectInstanceId],
          privateIpList: [this.selectInstancePrivateIp],
        })
          .then((res) => {
            if (id === this.projectId) {
              this.dialogSelectModelVisible = false;
              this.projectInstanceListLoading = false;
              this.projectInstanceList = res?.list || [];
              this.deployModeSimple = res?.deployMode === 'simple';
              this.noLoginMaster = res?.settings?.loginMaster === '1';
              this.currentProject = { ...this.getCurrentProject(), env: res?.defaultEnv };
              this.isOwner = this.getCurrentProject().isOwner || 0;
              if (!this.isChangeDataViewType) {
                if (res?.total <= 10 && this.tableDataTotal === 0) {
                  this.changeDataViewType = true;
                }
              }
              this.tableDataTotal = res?.total || 0;
              this.clusterNodeCount = res?.clusterNodeCount || 0;
              this.masterNodeInfo = { ...res?.masterNode, vpcId: res.defaultEnv.vpcId } || {};

              // 保存到sessionStorage  防止创建节点后 masterNodeInfo 信息不更新
              const currentProject = JSON.parse(sessionStorage.getItem('currentProject'));
              currentProject.masterNode = { ...res?.masterNode, vpcId: res.defaultEnv.vpcId };
              sessionStorage.setItem('currentProject', JSON.stringify(currentProject));
            }
            if (res?.list) {
              this.isMasterError();
            }
          })
          .catch(() => {
            this.projectInstanceListLoading = false;
          });
      }
    },

    // 手动切换 视图类型标志
    clickChangeDataViewType() {
      this.isChangeDataViewType = true;
      this.changeDataViewType = !this.changeDataViewType;
    },

    /**
     * 创建节点
     *
     * 功能描述:
     * 1. 打开创建节点的对话框
     * 2. 重置相关状态
     * 3. 调用子组件的创建节点方法
     *
     * @returns {void}
     */
    clickCreateDialog() {
      this.isCreateAdminNode = false; // 重置管理节点创建标志
      this.loading = false; // 重置加载状态
      this.dialogSelectModelVisible = true; // 显示选择模型对话框
      this.$nextTick(() => {
        this.$refs.createDialog.createAdminNode('newNode', {
          deployModeSimple: this.deployModeSimple,
          masterRegion: this.masterNodeInfo.region,
        }); // 在下一个DOM更新周期调用创建节点方法
      });
    },

    /**
     * 性能监控
     */
    async clickMonitorDialog() {
      try {
        await this.$store.dispatch('app/getProjectInfo');
        await window.open('/cvmMonitor/d/xfpJB9FGz', '_blank');
      } catch (e) {
        this.$message(this.$t('computingCluster.resource.getNodeMonitorDataFailed'), e);
      }
    },

    /**
     * 检查是否能创建节点（判断是否存在正常状态的主节点）
     * @returns {void} 无返回值，直接设置组件实例的isNotMaster属性
     */
    isMasterError() {
      // 遍历项目实例列表
      this.projectInstanceList.forEach((item) => {
        // 判断当前实例是否是主节点且状态正常
        // 只要存在一个正常的主节点，isNotMaster就会被设为false
        this.isNotMaster = !(item.nodeType === 'master' && item.status !== this.cvmStatusFilter.CvmStatusNormal);
      });
    },

    /**
     * 登录节点
     */
    startNode(instanceId, type, nodeType) {
      if (this.deployModeSimple && nodeType === 'login') {
        type = 'loginSimple';
      }
      window.open(`/remoteDestop?instanceId=${instanceId}&vncUser=${type}`);
    },

    /**
     * 创建主节点函数
     * @param {Object} data - 创建主节点所需的数据对象
     * @description
     * 1. 设置创建主节点标志位为true
     * 2. 显示模型选择对话框
     * 3. 关闭加载状态
     * 4. 在下一个DOM更新周期调用子组件的createAdminNode方法
     */
    recreate(data) {
      // this.$confirm('您已选择关闭超线程功能。此操作需要提前联系腾讯云客服申请白名单权限，否则实例将保持默认超线程设置？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(() => {
      this.isCreateAdminNode = true;
      this.dialogSelectModelVisible = true;
      this.loading = false;
      this.$nextTick(() => {
        this.$refs.createDialog.createAdminNode(data, this.currentProject);
      });
      // }).catch(() => {
      //   this.$message({
      //     type: 'info',
      //     message: '已取消创建管理节点'
      //   });
      // });
    },

    /**
     * 导入管理节点
     */
    importMasterNode() {
      this.importMasterNodeForm = {
        region: '',
        projectEnvId: '',
        cloudInstanceId: '',
      };
      this.importMasterNodeVisible = true;
    },

    /**
     * 获取项目环境信息
     */
    async getProjectEnvInfo() {
      this.importMasterNodeForm.projectEnvId = '';
      this.importMasterNodeForm.cloudInstanceId = '';
      this.importMasterNodeFormLoading = true;
      try {
        const res = await postRequest('/api/eda/common/project/getProjectEnvList', {
          offset: 0,
          limit: 999,
          region: this.importMasterNodeForm.region,
        });
        this.envList = res.list || [];
        this.importMasterNodeFormLoading = false;
      } catch (e) {
        this.importMasterNodeFormLoading = false;
        console.error(e);
      }
    },

    /**
     * 获取实例列表
     */
    getInstanceList() {
      this.importMasterNodeFormLoading = true;
      this.importMasterNodeForm.cloudInstanceId = '';
      const vpcId = this.envList.find(item => item.id === this.importMasterNodeForm.projectEnvId)?.vpcId;
      if (!vpcId) {
        this.$message.error('当前集群环境不完整，请前往集群管理页面补充完整！');
        this.importMasterNodeFormLoading = false;
        return;
      }
      const params = {
        region: this.importMasterNodeForm.region,
        offset: 0,
        filters: [
          {
            Name: 'vpc-id',
            Values: [vpcId],
          },
        ],
        limit: 100,
      };
      postRequest('/api/eda/common/tencentcloud/describeInstances', params)
        .then((res) => {
          // 处理实例列表数据
          this.importMasterNodeFormLoading = false;
          this.instanceList = res.instanceList || [];
        })
        .catch(() => {
          this.importMasterNodeFormLoading = false;
        });
    },

    /**
     * 导入管理节点
     */
    doneImportMasterNode() {
      if (this.importMasterNodeForm.region === '') {
        this.$message.error(this.$t('createNode.selectMachineRegion'));
        return;
      }
      if (this.importMasterNodeForm.projectEnvId === '') {
        this.$message.error(this.$t('createNode.selectClusterEnvInfo'));
        return;
      }

      if (this.importMasterNodeForm.cloudInstanceId === '') {
        this.$message.error(this.$t('computingCluster.resource.selectInstanceToImport'));
        return;
      }
      const publicIpAddresses = this.instanceList.find(item => item.InstanceId === this.importMasterNodeForm.cloudInstanceId)
        ?.PublicIpAddresses || [];

      if (publicIpAddresses.length === 0) {
        Message.error('导入实例未开启公网IP,暂不支持导入为管理节点，请重新选择实例！');
        return;
      }

      this.importMasterNodeFormLoading = true;
      postRequest('/api/eda/common/cluster/importClusterMaster', this.importMasterNodeForm)
        .then(() => {
          this.importMasterNodeFormLoading = false;
          this.$message.success(this.$t('computingCluster.resource.importMasterNodeSuccess'));
          this.importMasterNodeVisible = false;
          this.getResourceList();
        })
        .catch(() => {
          this.importMasterNodeFormLoading = false;
        });
    },
    /**
     * 创建镜像弹窗
     */
    createImages(item) {
      this.imagesForm.region = item.region;
      this.imagesForm.instanceId = item.instanceId;
      this.imagesForm.imageDescription = '';
      this.imagesForm.imageName = '';
      this.createImagesVisible = true;
    },

    testCreateImages(dryRunBol) {
      this.testImagesLoading = true;
      postRequest('/api/eda/common/tencentcloud/createImage', { ...this.imagesForm, dryRun: dryRunBol })
        .then(() => {
          this.$message.success(this.$t('computingCluster.resource.testImageSuccess'));
          this.testImagesLoading = false;
        })
        .catch(() => {
          this.testImagesLoading = false;
        });
    },

    /**
     * 创建镜像
     */
    doneCreateImages(dryRunBol) {
      this.createImagesLoading = true;
      postRequest('/api/eda/common/tencentcloud/createImage', { ...this.imagesForm, dryRun: dryRunBol })
        .then(() => {
          this.$message.success(this.$t('computingCluster.resource.createImageSuccess'));
          this.createImagesLoading = false;
          this.createImagesVisible = false;
          this.$emit('createImageInfo', this.imagesForm);
        })
        .catch(() => {
          this.createImagesLoading = false;
        });
    },

    /**
     * 更新edactld
     */
    updateEdactld() {
      this.$notify({
        title: this.$t('computingCluster.resource.updateMasterNode'),
        message: this.$t('computingCluster.resource.updateMasterNodeRestarting'),
        type: 'warning',
      });
      postRequest('/api/eda/common/cluster/updateEdactld')
        .then(() => {
          this.$notify({
            title: this.$t('computingCluster.resource.updateMasterNode'),
            message: this.$t('computingCluster.resource.updateMasterNodeSuccess'),
            type: 'success',
          });
        })
        .catch(() => {
          this.$message.error(this.$t('computingCluster.resource.updateMasterNodeFailed'));
        });
    },

    /**
     * 释放节点
     */
    terminateNode() {
      // 释放管理节点
      if (this.terminateInstancesType === 'master') {
        this.$confirm(
          this.$t('computingCluster.resource.destroyMasterNodeWarning'),
          this.$t('computingCluster.resource.tip'),
          {
            confirmButtonText: this.$t('computingCluster.resource.confirm'),
            cancelButtonText: this.$t('computingCluster.resource.cancel'),
            type: 'warning',
          },
        ).then(() => {
          postRequest('/api/eda/common/project/terminateClusterNode').then(() => {
            this.$message.success(this.$t('computingCluster.resource.releaseMasterNodeSuccess'));
            this.resetPagination();
            this.getResourceList();
          });
        });
      }

      // 释放子节点
      if (this.terminateInstancesType === 'child') {
        this.$confirm(
          this.$t('computingCluster.resource.destroyChildNodeWarning'),
          this.$t('computingCluster.resource.tip'),
          {
            confirmButtonText: this.$t('computingCluster.resource.confirm'),
            cancelButtonText: this.$t('computingCluster.resource.cancel'),
            type: 'warning',
          },
        ).then(() => {
          postRequest('/api/eda/common/cluster/terminateClusterComputeNodes', {
            clusterNodeIds: typeof this.clusterNodeId === 'number' ? [this.clusterNodeId] : this.clusterNodeId,
          })
            .then(() => {
              this.$message.success(this.$t('computingCluster.resource.destroyComputeNodeSuccess'));
              this.resetPagination();
              this.getResourceList();
            })
            .catch((e) => {
              this.$message(this.$t('computingCluster.resource.releaseFailed', { error: e }));
            });
        });
      }
    },

    /**
     * 释放子节点
     * @param id 节点id
     * @param type 节点类型 master 主节点、 child 子节点
     */
    async releaseInstance(id, type) {
      this.clusterNodeId = id;
      this.terminateInstancesType = type;
      if (this.loginType === 'qq') {
        this.terminateNode();
      } else {
        try {
          if (!this.mfaSdk) {
            this.mfaSdk = await use('mfa-sdk');
          }
          this.mfaSdk.verify({ api: 'cvm:TerminateInstances' }).then(() => {
            // 展示确认弹窗
            this.terminateNode();
          });
        } catch (e) {
          this.$message({
            type: 'error',
            message: this.$t('computingCluster.resource.mfaAuthFailed'),
          });
        }
      }
    },

    /**
     * deleteNode 删除节点
     * @param id 被删除的节点id
     */
    deleteNode(id) {
      this.$confirm(this.$t('computingCluster.resource.deleteNodeWarning'), this.$t('computingCluster.resource.tip'), {
        confirmButtonText: this.$t('computingCluster.resource.confirm'),
        cancelButtonText: this.$t('computingCluster.resource.cancel'),
        type: 'warning',
      }).then(() => {
        postRequest('/api/eda/common/cluster/DeleteTerminatedClusterNodes', { clusterNodeIds: [id] }).then(() => {
          this.$message.success(this.$t('computingCluster.resource.deleteComputeNodeSuccess'));
          this.resetPagination();
          this.getResourceList();
        });
      });
    },

    /**
     * 删除团队
     */
    deleteProject() {
      this.$confirm(
        this.$t('computingCluster.resource.deleteTeamConfirm'),
        this.$t('computingCluster.resource.deleteTeam'),
        {
          confirmButtonText: this.$t('computingCluster.resource.confirm'),
        },
      )
        .then(() => {
          postRequest('/api/eda/common/project/destroyProject').then(() => {
            // 清除当前团队
            Cookies.remove('CurrentProjectId');
            window.sessionStorage.removeItem('currentProject');
            Message.success(this.$t('computingCluster.resource.deleteTeamSuccess'));
            this.$store.dispatch('app/getProjectList');
          });
        })
        .catch(() => {
          // Message.info('取消删除');
        });
    },

    // 清除团队数据
    closeProjectData() {
      this.releaseInstance(0, 'team');
    },

    /**
     * 获取项目全部队列列表
     * **/
    getQueueList() {
      // 获取项目全部队列列表
      postRequest('/api/eda/common/cluster/describeQueueList', {}).then((res) => {
        this.queueNameFilterList = res?.queueList || [];
      });
    },
  },
  async mounted() {
    /**
     * 组件挂载时的初始化操作
     * 1. 获取当前项目信息
     * 2. 初始化分页并获取资源列表
     * 3. 如果是腾讯云用户,初始化MFA SDK
     * queueNameFilterList
     */
    // 获取项目id
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
    this.currentProject = currentProject;
    this.loginType = sessionStorage.getItem('loginType');
    // 获取节点列表
    this.resetPagination();
    await this.getResourceList();
    this.getQueueList();
    // 如果是腾讯云用户
    if (this.loginType === 'cloud') {
      await setupMfaSdk();
    }
  },
};
</script>

<style lang="scss" scoped>
.status__color-create {
  color: #165bcf;
}

.status__color-Normal {
  color: #0bc740;
}

.status__color-InDestruction,
.status__color-Destruction,
.status__color-Abnormal {
  color: #d12734;
}

.monitoring__button--height {
  float: right;
  margin-right: 10px;
}

.create__button--right {
  float: right;
}

// 按钮高度
.button_height {
  height: 30px;
}

// 弹窗的右边距
//.thirdStep {
//  ::v-deep .el-form-item {
//    margin-bottom: 16px;
//  }
//}
// 节点列表flex布局
.overview {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  overflow: auto;
  height: calc(100% - 60px);
}

.overview-wrapper {
  width: 100%;
}

// 节点信息内容
.content-item {
  width: 334px;
  height: 340px;
  background-color: #fff;
  padding: 16px 20px 14px 14px;
  margin: 0 36px 36px 0;
  cursor: pointer;
  float: left;
}

.tagsInfo_box {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  span {
    margin-left: 6px;
  }

  span:first-child {
    margin-left: 0px;
  }
}

// 节点信息单条长度
.split-item {
  height: 10px;
  line-height: 18px;
  color: #999999;
  white-space: nowrap;
  text-overflow: ellipsis;

  ::v-deep .el-form-item__label {
    font-size: 12px;
  }

  ::v-deep .el-form-item__content {
    font-size: 12px;
  }
}

// 节点信息title字体
.overview-title {
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 12px;
}

// 表单按钮margin设置 向右浮动
.form-button {
  margin-top: 15px;
  float: right;
}

// 表单label
//::v-deep .el-form-item__label:before {
//  content: ''!important;
//  margin: 0 !important;
//}

// 去除按钮圆角
::v-deep .form-button.el-button {
  border-radius: 0;
}

.monitoring__button--right {
  float: right;
  margin-right: 10px;
}

.div_height_100 {
  height: 100%;

  .no-data {
    height: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
  }
}

.wrapper_box {
  overflow-x: auto;
  height: 100%;

  .no-data {
    height: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
  }
}

.MFA_popover--img {
  width: 150px;
  height: 150px;
}

.terminate_dialog--div {
  background-color: #d4e3fc;
  height: 50px;
  line-height: 50px;
  color: #001f97;
  padding-left: 20px;
}

.switchMenuIcon {
  height: 40px;
  line-height: 40px;
  text-align: left;
  width: 100px;
  display: inline-block;

  i {
    user-select: none;
    font-size: 16px;
  }
}

.mfa_cls {
  width: 300px;
}

.table_width {
  width: 100%;
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.overview-wrapper-pagination {
  float: left;
  display: flex;
  width: 100%;
  flex-direction: column-reverse;
}

.select-width-178 {
  width: 178px;
}

.select-width-240 {
  width: 240px;
}

// 表单容器样式
.form-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

// 表单项样式
.form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}

// 表单标签样式
.form-label {
  min-width: 80px;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  text-align: left;
  padding-right: 12px;
  box-sizing: border-box;
}

// 表单内容样式
.form-content {
  flex: 1;
  line-height: 40px;
}

// 分割项样式
.form-item.split-item {
  height: 10px;
  line-height: 18px;
  color: #999999;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-bottom: 8px;
}

.form-item.split-item .form-label {
  line-height: 18px;
  font-size: 12px;
}

.form-item.split-item .form-content {
  line-height: 18px;
  font-size: 12px;
}

//.refresh {
//  padding: 0;
//  font-size: 20px;
//}
</style>
